import React, { forwardRef } from 'react';
import styled from 'styled-components';

import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import DragPointerIcon from '@ad-scripts/presentation/components/common/icons/drag-pointer';

type PropsType = {
  className?: string;
  disabled: boolean;
  droppableId: string;
  items: unknown[];
  renderRow: Function;
  type: string;
};

const DraggableList = forwardRef(({ className, items, disabled, renderRow, droppableId, type }: PropsType, ref) => {
  return (
    <StyledListContainer ref={ref} className={className} role="list">
      <Droppable type={`${droppableId}:${type}`} droppableId={droppableId}>
        {provided => {
          return (
            <StyledContainer ref={provided.innerRef}>
              {items.map((row: any, idx: number) => {
                return (
                  <Draggable isDragDisabled={disabled} key={String(row.id)} draggableId={String(row.id)} index={idx}>
                    {(provided, snapshot) => renderRow({ index: idx, item: row, snapshot, provided })}
                  </Draggable>
                );
              })}
              {provided.placeholder}
            </StyledContainer>
          );
        }}
      </Droppable>
    </StyledListContainer>
  );
});

export const StyledListContainer = styled.div``;

export const DraggableListContent = ({ onDragEnd, children }) => {
  const dragEndHandler = result => {
    if (!result.destination) {
      return;
    }

    if (result.source.index === result.destination.index) {
      return;
    }

    onDragEnd && onDragEnd(result);
  };

  return <DragDropContext onDragEnd={dragEndHandler}>{children}</DragDropContext>;
};

export const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const DragPointer = ({ id, isDragging, provided }) => (
  <StyledPointerIconWrap isDragging={isDragging} {...provided.dragHandleProps}>
    <DragPointerIcon data-aid={id} width="16px" height="16px" />
  </StyledPointerIconWrap>
);

export const StyledPointerIconWrap = styled.span`
  width: 17px;
`;

export default DraggableList;
